import Noty from 'noty';

export default function noty(type, text) {
    new Noty({
        type: type,
        layout: 'topRight',
        theme: 'bootstrap-v4',
        text: text,
        timeout: '2000',
        closeWith: ['click'],
        progressBar: false
      }).show();
}